export default "__VITE_ASSET__Cw3EY5Xa__"